

export default {


    async ADD_NEW_EQUIPMENT_REVIEW_ORDER(state, order) {
        state.equipmentReviewOrders.splice(0, 0, order) 
    },
    async SET_EQUIPMENT_REVIEW_ORDER(state, equipmentReviewOrders) {
        state.equipmentReviewOrders = equipmentReviewOrders
    },
    async UPDATE_EQUIPMENT_REVIEW_ORDER(state, order) {
        const equipmentReviewOrderIndex = state.equipmentReviewOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.equipmentReviewOrders[equipmentReviewOrderIndex], order)
    },

    REMOVE_EQUIPMENT_REVIEW_ORDER(state, idOrder) {
        const equipmentReviewOrderIndex = state.equipmentReviewOrders.findIndex((p) => p.idOrder == idOrder)
        state.equipmentReviewOrders.splice(equipmentReviewOrderIndex, 1)

    },
    
    

}
 